import { jsxs as b, jsx as a } from "react/jsx-runtime";
import s from "react";
import { clsx as h } from "../../utils/clsx.js";
import '../../assets/Checkbox.css';const u = "_root_ucpv2_1", p = "_indicator_ucpv2_32", v = "_disabled_ucpv2_51", e = {
  root: u,
  "size-normal": "_size-normal_ucpv2_22",
  "size-large": "_size-large_ucpv2_25",
  indicator: p,
  disabled: v,
  "with-label": "_with-label_ucpv2_61"
}, g = s.memo(function(n) {
  const {
    value: o,
    onChange: l,
    label: c,
    size: r = "normal",
    disabled: i = !1,
    className: d
  } = n, t = s.useId(), _ = s.useCallback(() => {
    l(!o);
  }, [o, l]), m = h(e.root, d, e[`size-${r}`], {
    [e.disabled]: i,
    [e["with-label"]]: !!c
  });
  return /* @__PURE__ */ b("label", { className: m, htmlFor: t, children: [
    /* @__PURE__ */ a(
      "input",
      {
        type: "checkbox",
        checked: o,
        disabled: i,
        onChange: _,
        id: t
      }
    ),
    /* @__PURE__ */ a("div", { className: e.indicator }),
    /* @__PURE__ */ a("div", { className: e.label, children: c })
  ] });
});
export {
  g as Checkbox
};
